import { toCurrency } from "./formatter";

const normalizeNumberString = (value) => {
  if (value === "") return "";
  const raw = String(value).replaceAll(",", "").trim();
  if (raw === "") return "";

  let cleaned = raw.replace(/[^0-9.]/g, "");
  const parts = cleaned.split(".");
  if (parts.length > 1) {
    cleaned = `${parts[0]}.${parts.slice(1).join("")}`;
  }

  if (cleaned === ".") {
    return "0.";
  }

  return cleaned;
};

const parserFormatNumInput = {
  parse: (v) => {
    if (v === "") return null;
    const cleaned = normalizeNumberString(v);
    if (cleaned === "") return null;
    return cleaned;
  },
  format: (v) => {
    if (v === "") return "";
    if (v === undefined || v === null) return ""; // TODO perlu di tes tadinya return undefined bukan return ""

    const cleaned = normalizeNumberString(v);
    if (cleaned === "") return "";

    const part = cleaned.split(".", 2);
    if (part.length === 2) {
      return `${toCurrency(false).format(part[0])}.${part[1]}`;
    }

    return toCurrency(false).format(part[0]);
  },
};
export default parserFormatNumInput;
